import { SSP_ERRORS } from './errors/ssperror';

export default class SspWrapperItemModel {
  constructor(jsonItem) {
    this.jsonItem = jsonItem;
    this.id = Math.floor(Math.random() * 1000000);
  }

  get type() {
    return this.jsonItem?.cn;
  }

  get xml() {
    return this.jsonItem.e?.xml;
  }

  get tag() {
    return this.jsonItem.e?.uri;
  }

  get cid() {
    return this.jsonItem?.cid;
  }

  isError() {
    if (!this.xml && !this.tag) {
      return SSP_ERRORS.SSP_AD_EMPTY;
    }
    return false;
  }

  get dataTracking() {
    const [trakings] = this.jsonItem.t ? this.jsonItem.t : [];
    return trakings;
  }
}
